var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath598(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.968,
    height: 16.968,
    viewBox: "0 0 16.968 16.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M78.484,15.907a7.423,7.423,0,1,1,7.423-7.423,7.432,7.432,0,0,1-7.423,7.423M78.484,0A8.484,8.484,0,1,1,70,8.484,8.494,8.494,0,0,1,78.484,0ZM81.51,10.76l-2.5-2.5V3.712a.53.53,0,0,0-1.06,0V8.484a.529.529,0,0,0,.155.374L80.76,11.51a.53.53,0,1,0,.75-.75Z",
    transform: "translate(-70)",
    fill: "#7e7e7e",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath598);
export default __webpack_public_path__ + "static/media/Path 598.83c17995b142b63bc7f0fd921b3b64b7.svg";
export { ForwardRef as ReactComponent };